import { render, staticRenderFns } from "./loadApp1.vue?vue&type=template&id=4539067f&scoped=true&"
import script from "./loadApp1.vue?vue&type=script&lang=js&"
export * from "./loadApp1.vue?vue&type=script&lang=js&"
import style0 from "./loadApp1.vue?vue&type=style&index=0&id=4539067f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4539067f",
  null
  
)

export default component.exports